import {
  ManeuverPosition,
  RouteResponse as Route,
  RouteResponseManeuver as ManeuverType,
} from '@busie/api'
import { Location } from '@busie/utils'
import { Marker } from '../models/Marker'

export const getMarkerFromLocation = (location: Location): Marker => {
  return {
    lat: location.latitude as number,
    lng: location.longitude as number,
  }
}

export const getLatLongFromLocation = (location: Omit<Location, '_id'>): string => {
  return `${location.latitude},${location.longitude}`
}

/**
 * Extract map markers from a route response.
 *
 * NOTE: The HERE Maps API no longer returns leg.start/leg.end position data.
 * We now use route.waypoints[] which contains all positions in order:
 * [origin, ...intermediate_stops, destination]
 *
 * @see BUSIE-2697 for context on this API contract change
 */
export const getMarkersFromRoute = (route: Route | null): Marker[] => {
  if (!route?.waypoints?.length) {
    return []
  }

  return route.waypoints
    .filter((waypoint) => waypoint?.position)
    .map((waypoint) => ({
      lat: waypoint.position.latitude,
      lng: waypoint.position.longitude,
    }))
}

export const secondsToMinutes = (seconds: number) => {
  return (seconds / 60).toFixed(2)
}

export const getAllManeuversFromRoute = (route: Route): ManeuverType[] => {
  let maneuvers: ManeuverType[] = []

  route.legs.forEach((leg) => {
    maneuvers = maneuvers.concat(leg.maneuvers)
  })

  return maneuvers
}

export const getTextOnlyFromHtmlMarkup = (htmlText: string): string => {
  const doc = new DOMParser().parseFromString(htmlText, 'text/html')
  return doc.body.textContent || ''
}

export const getPositionFromIndex = (index: number, maneuversLength: number): ManeuverPosition => {
  if (index === 0) return 'origin'
  if (index === maneuversLength - 1) return 'destination'
  return 'middle'
}
